// extracted by mini-css-extract-plugin
export default {"cardStack":"cardStack__bhRRu","stackContainer":"stackContainer__EOeAH","stack":"stack__XBBkC","expandingSection":"expandingSection__uVPQr"};